const settings = window.settings;
export default settings;



// WEBPACK FOOTER //
// ./src/config/settings/index.js